// @ts-nocheck
import { getCookie, setCookie } from "@insite/client-framework/Common/Cookies";
import useAppDispatch from "@insite/client-framework/Common/Hooks/useAppDispatch";
// import StyledWrapper, { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper"; // Starter Custom Code
import { PageLinkModel } from "@insite/client-framework/Services/ContentService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import setInitialValues from "@insite/client-framework/Store/Components/AddressDrawer/Handlers/SetInitialValues";
import setNavDrawerIsOpen from "@insite/client-framework/Store/Components/AddressDrawer/Handlers/SetNavDrawerIsOpen";
import {
    getCurrencies,
    getFulfillmentLabel,
    getIsPunchOutSession,
    getLanguages,
    getSettingsCollection,
} from "@insite/client-framework/Store/Context/ContextSelectors";
import cancelPunchOut from "@insite/client-framework/Store/Context/Handlers/CancelPunchOut";
import setCurrency from "@insite/client-framework/Store/Context/Handlers/SetCurrency";
import setLanguage from "@insite/client-framework/Store/Context/Handlers/SetLanguage";
import signOut from "@insite/client-framework/Store/Context/Handlers/SignOut";
import { getHeader, getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getWidgetsByPageId } from "@insite/client-framework/Store/Data/Widgets/WidgetSelectors";
// import { getPageLinkByPageType, LinkModel, useGetLinks } from "@insite/client-framework/Store/Links/LinksSelectors"; // Store Custom Code
import translate from "@insite/client-framework/Translate";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button, { ButtonIcon, ButtonPresentationProps } from "@insite/mobius/Button";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Icon, { IconProps } from "@insite/mobius/Icon";
import Globe from "@insite/mobius/Icons/Globe";
import MapPin from "@insite/mobius/Icons/MapPin";
// import Menu from "@insite/mobius/Icons/Menu"; // Starter Custom Code
// import User from "@insite/mobius/Icons/User"; // Starter Custom Code
import { MappedLink } from "@insite/mobius/Menu";
// import PanelMenu, { PanelMenuPresentationProps } from "@insite/mobius/PanelMenu"; // Starter Custom Code
import PanelRow, { PanelRowPresentationProps } from "@insite/mobius/PanelMenu/PanelRow";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import omitSingle from "@insite/mobius/utilities/omitSingle";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import React, { FC, useMemo } from "react";
import { connect, ResolveThunks } from "react-redux";
import styled, { css, ThemeProps, useTheme } from "styled-components";

import StyledWrapper, { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper";
import { Dictionary } from "@insite/client-framework/Common/Types";
import { FulfillmentMethod } from "@insite/client-framework/Services/SessionService";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import AccountMessagesCount, {
    AccountMessagesCountPresentationProps,
} from "@store/Library/Components/Toolkit/AccountMessagesCount";
import FormActions from "@store/Library/Components/Toolkit/FormActions";
import CubeFill from "@store/Library/Components/Toolkit/Icons/Cube/CubeFill";
import Menu from "@store/Library/Components/Toolkit/Icons/Menu";
import PersonFill from "@store/Library/Components/Toolkit/Icons/Person/PersonFill";
import SettingsLine from "@store/Library/Components/Toolkit/Icons/Settings/SettingsLine";
import Drawer, { DrawerPresentationProps } from "@store/MobiusOverrides/Drawer/Drawer";
import PanelMenu, { PanelMenuPresentationProps } from "@store/MobiusOverrides/PanelMenu/PanelMenu";
import NavigationModeMenu, { NavigationModeCookieName } from "@store/Overrides/Components/NavigationModeMenu";
import { headerLinkListIcons } from "@store/Overrides/Widgets/Header/HeaderLinkList";
import { menuPanelContentRowStyles, menuPanelRowStyles } from "@store/Themes/common/mixins/menu";
import { formGridProps } from "@store/Themes/common/props/form";
import { headerIconButtonProps } from "@store/Themes/common/props/header";
import { menuPanelProps } from "@store/Themes/common/props/menu";
import useIsDuplicate from "@toolkit/Framework/Common/Hooks/useIsDuplicate";
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";
import { pxToRem, pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { LinkModelWithIcon } from "@toolkit/Framework/Store/Links/LinksSelectors";
import { iconColorStyles, iconOffsetStyles, iconScalableStyles } from "@toolkit/Themes/common/mixins";

/* Store Custom Code - Start */
import { IconWrapper } from "@insite/mobius/Icon";
import Person from "@store/Library/Components/Icons/Person/PersonFill";
import { IconPresentationProps } from "@insite/mobius/Icon/Icon";
import Language from "@store/Library/Components/Icons/Language";
import StoreUser from "@store/Library/Components/Icons/StoreUser";
import { getPageLinkByPageType, useGetLinks } from "@insite/client-framework/Store/Links/LinksSelectors";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import setFlyoutDrawerIsOpen from "@insite/client-framework/Store/Components/AddressDrawer/Handlers/SetFlyoutDrawerIsOpen";
import removeCart from "@insite/client-framework/Store/Data/Carts/Handlers/RemoveCart";
import setSignInOverlayIsOpen from "@insite/client-framework/Store/Components/SignInOverlay/Handlers/SetSignInOverlayIsOpen";
import { LinkPresentationProps } from "@store/MobiusOverrides/Link/Link";
import { transitionHoverStyles } from "@store/Themes/common/mixins/transition";
import { useDisplayName } from "@store/Framework/Store/Foundation/Context/ContextHooks";
import getWidgetComponent from "@toolkit/Framework/Common/Utilities/getWidgetComponent";
/* Store Custom Code - End */
const LanguageMenu = getWidgetComponent("Common/LanguageMenu");

const mapStateToProps = (state: ApplicationState) => {
    /* Store Custom Code - Start */
    const { isAuthenticated, isGuest, firstName, lastName, userName } = getSession(state);
    const targetZone = ["Left", "Right", "SecondaryNavigation", "TertiaryNavigation"];

    const secondaryNavWidgets = getWidgetsByPageId(state, getHeader(state).id)
        .filter((widget: WidgetProps) => {
            return targetZone.includes(widget.zone);
        })
        .sort((a, b) => targetZone.indexOf(a.zone) - targetZone.indexOf(b.zone));

    const settingsMenu = secondaryNavWidgets.find(x => x.type === "Common/SettingsMenu");
    const currencyMenu = secondaryNavWidgets.find(x => x.type === "Common/CurrencyMenu");
    const languageMenu = secondaryNavWidgets.find(x => x.type === "Common/LanguageMenu");

    const headerLinkListLinkFields = secondaryNavWidgets
        .filter((widget: WidgetProps) => widget.type === "Header/HeaderLinkList")
        .reduce((y, x) => y.concat(x.fields.links), [] as LinkModelWithIcon[]);
    /* Store Custom Code - End */
    const displayPricingAndInventory = state.context.session?.displayPricingAndInventory || false;
    const currentMode = getCookie(NavigationModeCookieName) || "Storefront";
    const displayPricingAndInventoryToggles = displayPricingAndInventory && currentMode === "Storefront"; // Starter Custom Code

    return {
        currencies: getCurrencies(state),
        currentCurrencyId: state.context.session.currency?.id,
        currentCurrencySymbol: state.context.session.currency?.currencySymbol,
        languages: getLanguages(state),
        currentLanguage: state.context.session.language,
        currentLocation: getLocation(state),
        userName: state.context.session?.userName,
        isGuest: state.context.session?.isGuest,
        myAccountPageLink: getPageLinkByPageType(state, "MyAccountPage"),
        signInUrl: getPageLinkByPageType(state, "SignInPage"),
        vmiDashboardPageUrl: getPageLinkByPageType(state, "VmiDashboardPage")?.url,
        homePageUrl: getPageLinkByPageType(state, "HomePage")?.url,
        headerLinkListLinkFields,
        showCustomerMenuItem: getSettingsCollection(state).accountSettings.enableWarehousePickup,
        fulfillmentLabel: getFulfillmentLabel(state),
        navDrawerIsOpen: state.components.addressDrawer.navDrawerIsOpen,
        flyoutDrawerIsOpen: state.components.addressDrawer.flyoutDrawerIsOpen,
        isPunchOutSession: getIsPunchOutSession(state),
        cart: getCurrentCartState(state).value,
        visibilityState: findVisibilityState(state.data.pages.widgetsById),
        displayPricingAndInventoryToggles, // Starter Custom Code
        // Starter Custom Code
        fulfillmentMethod: state.components.addressDrawer.fulfillmentMethod,
        showAddressesSelector: isAuthenticated && !isGuest,
        userDisplayName: firstName ? `${firstName}${lastName ? ` ${lastName}` : ""}` : userName,
        showCurrencyMenu: Boolean(currencyMenu),
        showCurrencyIcon: Boolean(currencyMenu?.fields.showIcon),
        showLanguageMenu: Boolean(languageMenu),
        showLanguageIcon: Boolean(languageMenu?.fields.showIcon),
        showSettingsMenu: Boolean(settingsMenu),
        showSettingsIcon: Boolean(settingsMenu?.fields.showIcon),
        showInventoryToggle: Boolean(settingsMenu?.fields.showInventoryToggle) && displayPricingAndInventoryToggles,
        showPricingToggle: Boolean(settingsMenu?.fields.showPricingToggle) && displayPricingAndInventoryToggles,
    };
};

const mapDispatchToProps = {
    setCurrency,
    setLanguage,
    signOut,
    cancelPunchOut,
    setInitialValues,
    setNavDrawerIsOpen,
    setFlyoutDrawerIsOpen,
    removeCart,
    setSignInOverlayIsOpen,
};
interface OwnProps {
    links: MappedLink[];
    showQuickOrder: boolean;
    quickOrderLink: PageLinkModel | undefined;
    displayVmiNavigation?: boolean;
    vmiPageLinks?: (PageLinkModel | undefined)[];
    displayModeSwitch?: boolean;
    currentMode?: string;
    isCompactHeaderFlyout?: boolean;
    showFlyoutPricingToggle?: boolean;
    showFlyoutInventoryToggle?: boolean;
    rootElementSelector?: string;
    allowOpenParentLinks?: boolean;
    // Starter Custom Code
    uniqueId?: string;
}

type Props = OwnProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    HasHistory &
    ThemeProps<BaseTheme>;
export interface NavigationDrawerStyles {
    menuTriggerButton?: ButtonPresentationProps;
    drawer?: DrawerPresentationProps;
    drawerSectionWrapper?: InjectableCss;
    panelMenu?: PanelMenuPresentationProps;
    panelSectionWrapper?: InjectableCss;
    menuRowIcon?: IconProps;
    userRowTypography?: TypographyPresentationProps;
    punchOutUserRowText?: TypographyPresentationProps;
    mainNavigationRow?: PanelRowPresentationProps;
    mainNavigationRowIcon?: IconProps;
    punchOutNavigationRowIcon?: IconProps;
    mainNavigationRowTypography?: TypographyPresentationProps;
    logoLinks?: PanelRowPresentationProps & { typographyProps: TypographyPresentationProps };
    currencySymbol?: TypographyPresentationProps;
    changeCustomerRow?: PanelRowPresentationProps;
    changeCustomerRowContainer?: GridContainerProps;
    fulfillmentMethodGridItem?: GridItemProps;
    addressesGridItem?: GridItemProps;
    pickUpAddressGridItem?: GridItemProps;
    applyButtonGridItem?: GridItemProps;
    signOutRow?: PanelRowPresentationProps;
    signOutRowText?: TypographyPresentationProps;
    // Starter Custom Code
    menuIcon?: IconProps;
    languageMenu?: LinkPresentationProps;
    // Store Custom Code
    mainPanelMenu?: PanelMenuPresentationProps;
    userRowLabelTypography?: TypographyPresentationProps;
    userRowTypographyWrapper?: InjectableCss;
    secondaryPanelMenu?: PanelMenuPresentationProps;
    secondaryNavigationRow?: PanelRowPresentationProps;
    tertiaryRowTypography?: TypographyPresentationProps;
    loginNavigationRow?: PanelRowPresentationProps;
    languageMenuWrapper?: InjectableCss;
    languageIcon?: IconPresentationProps;
}

const StyledSection = getStyledWrapper("section");
const StyledSpan = getStyledWrapper("span");

// Starter Custom Code
const drawerContentWidth = [100, 60, 40];
// Starter Custom Code

/* Store Custom Code - Start */
const titleButtonStyles = css`
    display: flex;
    justify-content: center;
    align-items: center;
    height: ${pxToRem(50)};
    width: ${pxToRem(50)};

    border-radius: 0;
    border: none;
    background: ${getColor("primary")};
    outline: none;
`;
/* Store Custom Code - End */

export const navigationDrawerStyles: NavigationDrawerStyles = {
    menuTriggerButton: headerIconButtonProps,
    drawer: {
        size: 400,
        cssOverrides: {
            drawerContainer: css`
                max-width: 340px; /* Store Custom Code */
            `,
            drawerContent: css`
                width: 100%;
                overflow: hidden;

                > * {
                    height: 100%;
                    background-color: ${getColor("common.background")};
                }
            `,
            drawerBody: css`
                display: flex;
                flex-direction: column; /* Store Custom Code */
                overflow: hidden;
                background-color: ${getColor("common.background")}; /* Store Custom Code */
                box-shadow: none;
            `,
            drawerTitle: css`
                align-items: baseline;
                padding: 0;
                margin-left: auto;
                background-color: transparent;

                /* Store Custom Code - Start */
                > button {
                    background-color: ${getColor("primary")};
                    color: ${getColor("primary.contrast")};

                    &:focus {
                        outline: none;
                        background-color: ${getColor("secondary")};
                    }
                }

                /* Store Custom Code - End */
            `,
            titleButton: titleButtonStyles, // Store Custom Code
        },
    },
    drawerSectionWrapper: {
        css: css`
            &:first-child {
                margin-top: 0;
                padding-bottom: 10px;
                background: ${getColor("common.shadesLight")}; /* Store Custom Code */
            }
            margin-top: 20px;
        `,
    },
    panelMenu: {
        closeButtonProps: { css: titleButtonStyles }, // Store Custom Code
        cssOverrides: {
            wrapper: css`
                > button {
                    width: 100%; /* Store Custom Code */
                }
            `,
        },
    },
    panelSectionWrapper: {
        css: css`
            display: flex;
            align-items: center;
        `,
    },
    menuRowIcon: {
        size: 22,
        css: css`
            margin-top: -2px;
            margin-right: 10px;
            width: 24px;
            display: inline-block;
            text-align: center;
            vertical-align: middle;
        `,
    },
    userRowTypography: {
        color: "secondary.contrast",
        css: css`
            font-weight: ${({ theme }) => theme.design.typography.weight.bold}; /* Store Custom Code */
            font-size: ${({ theme }) => theme.design.typography.size.smaller}; /* Store Custom Code */
        `,
    },
    punchOutUserRowText: {
        transform: "capitalize",
        color: "primary",
        css: css`
            font-weight: ${({ theme }) => theme.design.typography.weight.medium};
        `,
    },
    mainNavigationRow: {},
    mainNavigationRowIcon: {
        src: StoreUser, // Store Custom Code
        color: "secondary.contrast", // Store Custom Code
        size: 22,
        css: css`
            margin-top: -2px;
            margin-right: 10px;
            width: 24px;
            display: inline-block;
            text-align: center;
            vertical-align: middle;
            svg {
                color: ${getColor("secondary.contrast")}; /* Store Custom Code */
            }
        `,
    },
    punchOutNavigationRowIcon: {
        src: Person,
        color: "primary",
        size: 22,
        css: css`
            margin-top: -2px;
            margin-right: 10px;
            width: 24px;
            display: inline-block;
            text-align: center;
            vertical-align: middle;
        `,
    },
    mainNavigationRowTypography: {
        transform: "capitalize",
        color: "text", // Store Custom Code
        css: css`
            font-weight: ${({ theme }) => theme.design.typography.weight.bold}; /* Store Custom Code */
            font-size: ${({ theme }) => theme.design.typography.size.large}; /* Store Custom Code */
        `,
    },
    logoLinks: {
        color: "common.background",
        typographyProps: {
            ellipsis: true,
            transform: "capitalize",
        },
        css: css`
            margin: 2px;
        `,
    },
    currencySymbol: {
        size: 22,
        css: css`
            margin-top: -4px;
            margin-right: 10px;
            width: 24px;
            display: inline-block;
            text-align: center;
            vertical-align: middle;
        `,
    },
    changeCustomerRow: {
        css: css`
            &:focus {
                outline: none;
            }
        `,
    },
    changeCustomerRowContainer: { gap: 15 },
    fulfillmentMethodGridItem: { width: 12 },
    addressesGridItem: { width: 12 },
    pickUpAddressGridItem: { width: 12 },
    applyButtonGridItem: { width: 12 },
    /* Store Custom Code - Start */
    signOutRow: {
        css: css`
            font-size: ${({ theme }) => theme.design.typography.size.smallest};
            color: ${getColor("primary")};
            font-weight: ${({ theme }) => theme.design.typography.weight.bold};
        `,
    },
    /* Store Custom Code - End */
    signOutRowText: {
        transform: "uppercase",
    },
    menuIcon: {
        color: "primary",
        size: 28,
        css: css`
            ${transitionHoverStyles()}

            &:hover {
                color: ${getColor("secondary")};
            }
        `,
    },
    /* Store Custom Code - Start */
    mainPanelMenu: {
        closeButtonProps: { css: titleButtonStyles } /* Store Custom Code */,
        cssOverrides: {
            wrapper: css`
                background-color: ${getColor("secondary")};

                > button {
                    width: 100%;
                    background: transparent;
                    color: ${getColor("secondary.contrast")};
                    :hover * {
                        color: ${getColor("secondary.contrast")};
                        > ${IconWrapper} {
                            color: ${getColor("secondary.contrast")};
                        }
                    }
                    > ${IconWrapper} {
                        color: ${getColor("secondary.contrast")};
                    }
                }
            `,
        },
    },
    userRowLabelTypography: {
        css: css`
            font-size: ${({ theme }) => theme.design.typography.size.smallest};
        `,
    },
    userRowTypographyWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
        `,
    },
    secondaryPanelMenu: {
        closeButtonProps: {
            css: titleButtonStyles,
        },
        cssOverrides: {
            wrapper: css`
                background-color: ${getColor("common.background")};

                > button {
                    width: 100%;
                    background: transparent;
                }
            `,
        },
    },
    /* Store Custom Code - End */

    secondaryNavigationRow: {
        css: css`
            background-color: ${getColor("common.background")};
            padding: ${x => x.theme.design.layout.spacing.small};
        `,
    },
    tertiaryRowTypography: {
        css: css`
            font-size: ${({ theme }) => theme.design.typography.size.smaller};
        `,
    },
    loginNavigationRow: {
        isCurrentCss: css`
            background-color: ${getColor("secondary")};
        `,
        css: css`
            background-color: ${getColor("secondary")};
            padding: ${pxToRem(18, 16)};
        `,
    },
    languageMenuWrapper: {
        css: css`
            font-size: ${({ theme }) => theme.design.typography.size.smaller};
            display: flex;
        `,
    },
    /* Store Custom Code - Start */

    languageIcon: {
        size: 22,
        src: Language,
        css: css`
            margin-right: ${pxToRem(5)};
        `,
    },
    /* Store Custom Code - End */
};

const styles = navigationDrawerStyles;

const NavigationDrawer = ({
    links,
    showQuickOrder,
    quickOrderLink,
    displayVmiNavigation,
    vmiPageLinks,
    displayModeSwitch,
    currentMode,
    isCompactHeaderFlyout,
    showFlyoutPricingToggle,
    showFlyoutInventoryToggle,
    rootElementSelector,
    currencies,
    currentCurrencyId,
    currentCurrencySymbol,
    languages,
    currentLanguage,
    currentLocation,
    userName,
    isGuest,
    myAccountPageLink,
    signInUrl,
    vmiDashboardPageUrl,
    homePageUrl,
    headerLinkListLinkFields,
    showCustomerMenuItem,
    fulfillmentLabel,
    navDrawerIsOpen,
    flyoutDrawerIsOpen,
    isPunchOutSession,
    cart,
    history,
    theme,
    displayPricingAndInventoryToggles,
    setCurrency,
    setLanguage,
    signOut,
    cancelPunchOut,
    setInitialValues,
    setNavDrawerIsOpen,
    setFlyoutDrawerIsOpen,
    removeCart,
    setSignInOverlayIsOpen,
    visibilityState,
    allowOpenParentLinks,
    // Starter Custom Code
    fulfillmentMethod,
    showAddressesSelector,
    userDisplayName,
    uniqueId,
    showCurrencyMenu,
    showCurrencyIcon,
    showLanguageMenu,
    showLanguageIcon,
    showSettingsMenu,
    showSettingsIcon,
    showInventoryToggle,
    showPricingToggle,
}: Props) => {
    const { links: headerLinkListLinks, hasMissingCategories } = useGetLinks(
        headerLinkListLinkFields,
        o => o.fields.destination,
    );

    if (hasMissingCategories) {
        return null;
    }
    const openDrawer = () => {
        setNavDrawerIsOpen({ navDrawerIsOpen: true });
        setInitialValues({});
    };

    const closeDrawer = () => {
        setNavDrawerIsOpen({ navDrawerIsOpen: false });
        setTimeout(() => setNavDrawerIsOpen({ navDrawerIsOpen: undefined }), 300);
    };

    const onSignOutHandler = () => {
        setNavDrawerIsOpen({ navDrawerIsOpen: false });
        isPunchOutSession ? cancelPunchOut() : signOut();
    };

    const currentPageUrl = currentLocation.pathname;
    const isOpen = isCompactHeaderFlyout ? flyoutDrawerIsOpen : navDrawerIsOpen;

    // Starter Custom Code
    const displayName = useDisplayName();
    // Starter Custom Code

    const tabDisabled = -1;
    return (
        <>
            <Button
                onClick={openDrawer}
                aria-label={translate("menu")}
                {...styles.menuTriggerButton}
                data-test-selector="expandMobileMenu"
            >
                <ButtonIcon src={Menu} {...styles.menuIcon} /> {/* Starter Custom Code */}
            </Button>
            <Drawer
                className="drawer"
                draggable
                position="left"
                {...styles.drawer}
                isOpen={isOpen}
                handleClose={closeDrawer}
                contentLabel="menu drawer"
            >
                <StyledSection {...styles.drawerSectionWrapper}>
                    {userName && !isGuest && !isPunchOutSession ? (
                        <PanelMenu
                            currentUrl={currentPageUrl}
                            panelTrigger={
                                <PanelRow hasChildren {...styles.mainNavigationRow}>
                                    <StyledSpan {...styles.panelSectionWrapper}>
                                        <Icon {...styles.mainNavigationRowIcon} />
                                        {/* Store Custom Code - Start */}
                                        <StyledWrapper {...styles.userRowTypographyWrapper}>
                                            <Typography {...styles.userRowLabelTypography}>
                                                {translate("My Account")}
                                            </Typography>
                                            <Typography {...styles.userRowTypography}>
                                                {displayName /* Starter Custom Code */}
                                            </Typography>
                                        </StyledWrapper>
                                        {/* Store Custom Code - End */}
                                    </StyledSpan>
                                </PanelRow>
                            }
                            menuItems={myAccountPageLink?.children ? myAccountPageLink.children : []}
                            /* Starter Custom Code */
                            maxDepth={1}
                            parent={myAccountPageLink} // Store Custom Code
                            /* Starter Custom Code */
                            closeOverlay={closeDrawer}
                            layer={0}
                            {...styles.mainPanelMenu} // Store Custom Code
                        />
                    ) : isPunchOutSession ? (
                        <PanelRow {...styles.mainNavigationRow}>
                            <StyledSpan {...styles.panelSectionWrapper}>
                                <Icon {...styles.punchOutNavigationRowIcon} />
                                <Typography {...styles.punchOutUserRowText}>{userName}</Typography>
                            </StyledSpan>
                        </PanelRow>
                    ) : (
                        <PanelRow
                            {...styles.loginNavigationRow} // Store Custom Code
                            isCurrent={currentPageUrl === signInUrl?.url}
                            onClick={closeDrawer}
                            onKeyPress={(event: React.KeyboardEvent<HTMLAnchorElement>) => {
                                if (event.key === " " && history && signInUrl?.url) {
                                    event.preventDefault();
                                    closeDrawer();
                                    history.push(signInUrl.url);
                                }
                            }}
                            href={signInUrl?.url}
                        >
                            <StyledSpan {...styles.panelSectionWrapper}>
                                <Icon {...styles.mainNavigationRowIcon} />
                                {/* Starter Custom Code */}
                                <Typography {...styles.userRowTypography}>{translate("Login")}</Typography>
                            </StyledSpan>
                        </PanelRow>
                    )}
                    {/* covers MainNavigation functionality */}

                    {links.map((link, index) => {
                        if (link.children && link.children.length > 0) {
                            return (
                                <PanelMenu
                                    key={`${index}${link.title}`}
                                    currentUrl={currentPageUrl}
                                    closeOverlay={closeDrawer}
                                    panelTrigger={
                                        <PanelRow hasChildren {...styles.mainNavigationRow}>
                                            <Typography {...styles.mainNavigationRowTypography}>
                                                {link.title}
                                            </Typography>
                                        </PanelRow>
                                    }
                                    menuItems={link.children}
                                    maxDepth={link.maxDepth || 3}
                                    layer={0}
                                    {...styles.panelMenu}
                                    parent={link} // Starter Custom Code
                                    {...styles.secondaryPanelMenu} // Store Custom Code
                                />
                            );
                        }
                        return (
                            <PanelRow
                                key={`${index}${link.title}`}
                                href={link.url}
                                target={link.openInNewWindow ? "_blank" : ""}
                                {...styles.mainNavigationRow}
                            >
                                <Typography {...styles.mainNavigationRowTypography}>{link.title}</Typography>
                            </PanelRow>
                        );
                    })}
                    {/* Starter Custom Code */}
                    {showQuickOrder && quickOrderLink && (
                        <PanelRow
                            isCurrent={currentPageUrl === quickOrderLink.url}
                            onClick={closeDrawer}
                            href={quickOrderLink.url}
                            {...styles.secondaryNavigationRow}
                        >
                            <Typography {...styles.mainNavigationRowTypography}>{quickOrderLink.title}</Typography>
                        </PanelRow>
                    )}
                    {headerLinkListLinks.length > 0 ? (
                        headerLinkListLinks.map((link, index) => (
                            <PanelRow
                                // Store Custom Code - added unique key
                                key={`${link.title}-${index}`}
                                {...styles.mainNavigationRow}
                                isCurrent={currentPageUrl === link.url}
                                onClick={closeDrawer}
                                href={link.url}
                                target={headerLinkListLinkFields[index].fields.openInNewWindow ? "_blank" : ""}
                            >
                                <Typography {...styles.tertiaryRowTypography} /* Store Custom Code */>
                                    {
                                        headerLinkListLinkFields[index].fields.overriddenTitle ||
                                            link.title /* Starter Custom Code */
                                    }
                                </Typography>
                            </PanelRow>
                        ))
                    ) : (
                        <></>
                    )}
                    {languages?.length && languages?.length > 1 ? (
                        /* Store Custom Code - Start */
                        <PanelRow tabIndex={tabDisabled}>
                            <StyledWrapper {...styles.languageMenuWrapper}>
                                <Icon {...styles.languageIcon} />
                                <LanguageMenu displayName {...styles.languageMenu} />
                            </StyledWrapper>
                        </PanelRow>
                    ) : /* Store Custom Code - End */
                    null}
                    {/* Starter Custom Code */}
                    {/* Starter Removed Code - QuickOrder - Native HeaderLinkList - Native Language Selector */}
                    {userName && !isGuest && (
                        <PanelRow onClick={onSignOutHandler} {...styles.signOutRow}>
                            <Typography>
                                {isPunchOutSession ? translate("Cancel PunchOut") : translate("Sign Out")}
                            </Typography>
                        </PanelRow>
                    )}
                </StyledSection>
            </Drawer>
        </>
    );
};

interface SelectorMenuProps {
    options?: MappedLink[];
    closeModal?: () => void;
    currentOption: React.ReactNode;
    currentOptionIcon: React.ReactNode;
    dataTestSelector?: string;
}

const SelectorMenu: React.FC<SelectorMenuProps> = ({
    options,
    closeModal,
    currentOption,
    currentOptionIcon,
    dataTestSelector,
}) => {
    if (!options || options.length <= 1) {
        return null;
    }

    const trigger = (
        <PanelRow hasChildren {...styles.logoLinks}>
            <StyledSpan {...styles.panelSectionWrapper}>
                {currentOptionIcon}
                <Typography
                    data-test-selector={`${dataTestSelector}_currentOption`}
                    {...styles.logoLinks?.typographyProps}
                >
                    {currentOption}
                </Typography>
            </StyledSpan>
        </PanelRow>
    );

    return (
        <PanelMenu
            data-test-selector={dataTestSelector}
            closeOverlay={closeModal}
            panelTrigger={trigger}
            menuItems={options}
            maxDepth={1}
            layer={0}
            {...styles.panelMenu}
        />
    );
};

function findVisibilityState(data: any): string | undefined {
    for (const key in data) {
        if (data[key].type === "Common/HeaderSignIn") {
            return data[key].generalFields.visibilityState;
        }
    }
    return undefined;
}

export default connect(mapStateToProps, mapDispatchToProps)(withHistory(NavigationDrawer));
